import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa nowej procedury',
      type: 'string',
      fieldRequired: true
    },
    procedureId: {
      title: 'Procedura na podstawie której ma zostać utworzona nowa',
      type: 'number',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
